import { Text } from '@medly-components/core';
import { CloseIcon as MedlyCloseIcon } from '@medly-components/icons';
import styled from 'styled-components';

export const ErrorContainerWrapper = styled.div`
    position: absolute;
    top: 7.2rem;
    left: 0;
    right: 0;
    z-index: 2;
    padding: 1.4rem 0;
    background: ${({ theme }) => theme.colors.errorBackground};
    display: flex;
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        top: 6.4rem;
    }
`;

export const ErrorContainer = styled.div`
    margin: 0 auto;
    display: inline-flex;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding-left: 2.4rem;
        align-items: flex-start;
    }
`;

export const ErrorText = styled(Text)`
    padding-left: 0.8rem;
`;

export const CloseIcon = styled(MedlyCloseIcon)`
    right: 9.6rem;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding: 0 3.4rem 0 3.2rem;
        position: initial;
        margin: auto 0;
        transform: translateY(0);
    }
`;
